import { Navigate, useSearchParams } from "react-router-dom";
import { resolveReturnUrl } from "../utils/authRedirect";

interface PublicRouteProps {
  children: React.ReactNode;
  isAuthenticated: boolean;
}

const PublicRoute = ({ children, isAuthenticated }: PublicRouteProps) => {
  const [searchParams] = useSearchParams();

  if (isAuthenticated) {
    const returnUrl = resolveReturnUrl(searchParams.get("returnUrl"));
    return <Navigate to={returnUrl || "/dashboard"} replace />;
  }

  return <>{children}</>;
};

export default PublicRoute;
